import * as constants from '../constants';

export default function ( h ) {
  const c = new PIXI.Container();

  const g = new PIXI.Graphics();
  c.addChild(g);
  g
  .clear()
  .beginFill(constants.darkBlue)
  .drawRect(0, 0, constants.screenWidth, h)
  .endFill();

  return c;
};
